module.exports = __webpack_public_path__ + "static/media/pic-3.13733088.jpg";